<template>
  <transition-group
    name="card-anim"
    class="cards"
    @before-enter="beforeEnter"
    @before-leave="beforeLeave"
    @enter="enter"
    @leave="leave"
    @after-leave="afterLeave"
    tag="div"
    v-bind:css="false"
  >
    <template v-for="(item, index) in visibleCards">
      <Card
        v-if="!item.isPromoCard"
        :card="item"
        :context="context"
        :backgroundColor="backgroundColor"
        :genderToShow="genderToShow"
        :key="item.id"
        :data-index="index"
        :data-leave-index="visibleCards.length - index"
        :imageFormat="imageFormat"
        :index="index"
        :summaryIsHidden="summaryIsHidden"
        :class="{ 'card--summary-is-hidden': summaryIsHidden }"
        :onCardClick="onProductCardClick"
        @mouseenter.native="selectCard(index)"
        @mouseleave.native="selectCard(-1)"
      />

      <PromoCard
        v-else
        :context="context"
        :key="item.id"
        :index="index"
        :promoCard="item"
        :data-index="index"
        :data-leave-index="visibleCards.length - index"
        :onCardView="onPromoCardView"
      ></PromoCard>
    </template>
  </transition-group>
</template>

<script>
import { CONTENTFUL_IMAGE_FORMAT } from '@/components/_shared/ImageContentful.vue'
import PromoCard from './PromoCard.vue'
import Card from './Card/Card.vue'
import settings from './card-settings'

export const CARDS_TRANSITION_TIME = 300

export default {
  name: 'Cards',
  components: { Card, PromoCard },
  props: {
    backgroundColor: {
      type: String,
    },

    genderToShow: {
      type: String,
    },

    cards: {
      type: Array,
      required: true,
    },

    context: {
      // Can be used to add context about where the card was used (e.g. 'search' - needed for GTM )
      type: String,
    },

    summaryIsHidden: {
      type: Boolean,
      required: false,
      default: false,
    },

    imageFormat: {
      type: String,
      default: CONTENTFUL_IMAGE_FORMAT.default,
      validator(value) {
        return Object.values(CONTENTFUL_IMAGE_FORMAT).includes(value)
      },
    },

    onProductCardClick: {
      type: Function,
      default() {
        return () => {}
      },
    },

    onPromoCardView: {
      type: Function,
    },

    onPromoCardClick: {
      type: Function,
      default() {
        return () => {}
      },
    },
  },

  computed: {
    visibleCards() {
      return this.cards.filter(card => this.isCardHavingVariant(card) || card.isPromoCard)
    },
  },

  methods: {
    isCardHavingVariant({ variants }) {
      return (
        variants?.length > 0 &&
        (!this.genderToShow ||
          !!variants?.find(({ gender }) => gender?.includes(this.genderToShow)))
      )
    },

    removeBodyTransitionClass() {
      document.body.classList.remove(settings.transitionClass)
    },

    selectCard(index) {
      this.removeBodyTransitionClass()
      if (On.Store.state.filter !== undefined) this.$store.commit('filter/selectCard', index)
    },

    beforeEnter(el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(30px)'
    },

    beforeLeave(el) {
      const transitions = [
        `box-shadow ${CARDS_TRANSITION_TIME}ms ease-in-out`,
        `opacity ${CARDS_TRANSITION_TIME * 0.8}ms ease-in`,
        `transform ${CARDS_TRANSITION_TIME}ms ease-in`,
      ]
      el.style.transition = transitions.join(', ')
    },

    enter(el, done) {
      let delay = el.dataset.index * 40
      setTimeout(() => {
        el.style.opacity = 1
        el.style.transform = 'translateY(0px)'
        done()
      }, delay)
    },

    leave(el, done) {
      const index = Number(el.dataset.leaveIndex)
      // Limit fading out of products to 200ms
      const delay = Math.min(index * 20, 200)

      // Staggered fade out of cards
      setTimeout(() => {
        el.style.opacity = 0
        setTimeout(() => {
          return done()
        }, 300)
      }, delay)
    },

    afterLeave(el) {
      if (On.Store.state.filter !== undefined && el.dataset.index === '0') {
        setTimeout(() => {
          this.$store.commit('filter/switchDisplayedCards')
        }, 100)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.cards {
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 100%;
}
</style>
